
define('modules/application/quoteTypesMenu',[
        'app',
        'backbone',
        './header',
        './subheader',
        './system-selection-multi',
        './system-selection-single',
        './popup'
    ],

    function(app, Backbone, Header, Subheader, SystemSelectionMulti, SystemSelectionSingle, Popup) {

        // Create a new module
        var QuoteTypesMenu = app.module();

        QuoteTypesMenu.Model = Backbone.Model.extend({
            defaults: {
                quoteTypeDefined: false,
                quoteType: ''
            },

            initialize: function() {

            },

            isQuoteTypeDefined: function() {
                if (this.get('quoteTypeDefined') === true)
                    return true;
                else
                    return false;
            },
            QuoteType: function() {
                return this.get('quoteType');
            }
        });

        QuoteTypesMenu.View = Backbone.View.extend({
            id: 'quote-type',
            tagName: 'section',
            template: 'application/quoteTypesMenu',
            events: {
                'click .button-quote-type': 'openSystemSelectionWindow',
            },

            serialize: function() {
                return {
                    app: app
                };
            },

            initialize: function() {
                this.model = new QuoteTypesMenu.Model();
                window.BticinoS4B.eventAggregator.bind("language:changed", this.render, this);
                this.resetSystem();
            },

            beforeRender: function() {

            },

            afterRender: function() {
                $('.contentQuoteTypes').css('min-height',$(window).height()-$('header').height()-2);
            },
            resetSystem: function(){
                window.BticinoS4B.modelToLoad.thermoregulation   = null;
                window.BticinoS4B.modelToLoad.intrusionDetection = null;
                window.BticinoS4B.modelToLoad.audioVideo         = null;
                window.BticinoS4B.modelToLoad.automation         = null;
                window.BticinoS4B.modelToLoad.automationSimple   = null;
                window.BticinoS4B.modelToLoad.energyManagement   = null;
                window.BticinoS4B.solution.audioVideo = {};
                window.BticinoS4B.solution.thermoregulation = {};
                window.BticinoS4B.solution.automation = {};
                window.BticinoS4B.solution.automationSimple = {};
                window.BticinoS4B.solution.energyManagement = {};
                window.BticinoS4B.solution.intrusionDetection = {};
                window.BticinoS4B.solution.audioVideo.inserted = false;
                window.BticinoS4B.solution.thermoregulation.inserted = false;
                window.BticinoS4B.solution.automation.inserted = false;
                window.BticinoS4B.solution.intrusionDetection.inserted = false;
                window.BticinoS4B.solution.automationSimple.inserted = false;
                window.BticinoS4B.solution.energyManagement.inserted = false;
                window.BticinoS4B.modelToExport                  = null;

                BticinoS4B.Instances.Models.ApplicationModel.set("projectId", undefined);
                BticinoS4B.Instances.Models.ApplicationModel.set("projectName", undefined);
                BticinoS4B.Instances.Models.ApplicationModel.set("projectCreated", undefined);
                BticinoS4B.Instances.Models.ApplicationModel.set("projectModified", undefined);
            },
            openSystemSelectionWindow: function(e) {
                BticinoS4B.Instances.Models.QuoteTypesMenuModel.set('quoteTypeDefined', true);
                BticinoS4B.Instances.Models.QuoteTypesMenuModel.set('quoteType', e.currentTarget.attributes.quotetype.value);
                // $.cookie('quoteType',BticinoS4B.Instances.Models.QuoteTypesMenuModel.get('quoteType'));
                BticinoS4B.checkTokenCookie();
            }

        });

        return QuoteTypesMenu;

    });